<template>
  <div class="main">
    <a-form :form="form" class="user-layout-login" ref="formLogin" id="formLogin">
      <a-tabs
        :activeKey="customActiveKey"
        :tabBarStyle="{ textAlign: 'center', borderBottom: 'unset' }"
        @change="handleTabClick">
        <a-tab-pane key="tab1" tab="账号密码登录">
          <a-form-item>
            <a-input
              size="large"
              v-decorator="['username',validatorRules.username,{ validator: this.handleUsernameOrEmail }]"
              type="text"
              placeholder="请输入帐户名">
              <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-input
              v-decorator="['password',validatorRules.password]"
              size="large"
              type="password"
              autocomplete="false"
              placeholder="密码">
              <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-form-item>

          <a-row :gutter="0">
            <a-col :span="16">
              <a-form-item>
                <a-input
                  v-decorator="['inputCode',validatorRules.inputCode]"
                  size="large"
                  type="text"
                  @change="inputCodeChange"
                  placeholder="请输入验证码">
                  <a-icon slot="prefix" type="smile" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8" style="text-align: right">
              <img v-if="requestCodeSuccess" style="margin-top: 2px;" :src="randCodeImage" @click="handleChangeCheckCode"/>
              <img v-else style="margin-top: 2px;" src="../../assets/checkcode.png" @click="handleChangeCheckCode"/>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>

      <!--<a-form-item>-->
        <!--<a-checkbox v-decorator="['rememberMe', {initialValue: true, valuePropName: 'checked'}]" >自动登录</a-checkbox>-->
      <!--</a-form-item>-->

      <a-form-item style="margin-top:24px">
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="loginBtn"
          @click.stop.prevent="handleSubmit"
          :disabled="loginBtn">确定
        </a-button>
      </a-form-item>
    </a-form>

    <two-step-captcha
      v-if="requiredTwoStepCaptcha"
      :visible="stepCaptchaVisible"
      @success="stepCaptchaSuccess"
      @cancel="stepCaptchaCancel"></two-step-captcha>
    <login-select ref="loginSelect" @success="loginSelectOk"></login-select>
  </div>
</template>

<script>
  //import md5 from "md5"
  import TwoStepCaptcha from '@/components/tools/TwoStepCaptcha'
  import { mapActions } from "vuex"
  import { timeFix } from "@/utils/util"
  import Vue from 'vue'
  import { ACCESS_TOKEN ,ENCRYPTED_STRING} from "@/store/mutation-types"
  import { putAction,postAction,getAction } from '@/api/manage'
  import { encryption , getEncryptedString } from '@/utils/encryption/aesEncrypt'
  import { USER_INFO } from "@/store/mutation-types"
  import LoginSelect from "./LoginSelect";
  import JSEncrypt from 'jsencrypt'
  import {PUBLIC_KEY } from '@/constants/project'

  export default {
    components: {
      LoginSelect,
      TwoStepCaptcha,
    },
    data () {
      return {
        customActiveKey: "tab1",
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        loginType: 0,
        requiredTwoStepCaptcha: false,
        stepCaptchaVisible: false,
        form: this.$form.createForm(this),
        encryptedString:{
          key:"",
          iv:"",
        },
        state: {
          time: 60,
          smsSendBtn: false,
        },
        validatorRules:{
          username:{rules: [{ required: true, message: '请输入用户名!'},{validator: this.handleUsernameOrEmail}]},
          password:{rules: [{ required: true, message: '请输入密码!',validator: 'click'}]},
          captcha:{rule: [{ required: true, message: '请输入验证码!'}]},
          inputCode:{rules: [{ required: true, message: '请输入验证码!'}]}
        },
        verifiedCode:"",
        inputCodeContent:"",
        inputCodeNull:true,
        currentUsername:"",
        currdatetime:'',
        randCodeImage:'',
        requestCodeSuccess:false,
      }
    },
    created () {
      this.currdatetime = new Date().getTime();
      this.getRouterData();
      this.handleChangeCheckCode();
      // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
      //this.getEncrypte();
      // update-end- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
    },
    methods: {
      ...mapActions(['Login', 'Logout', 'PhoneLogin']),
      // handler
      handleUsernameOrEmail (rule, value, callback) {
        const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
        if (regex.test(value)) {
          this.loginType = 0
        } else {
          this.loginType = 1
        }
        callback()
      },
      handleTabClick (key) {
        this.customActiveKey = key
        // this.form.resetFields()
      },
      handleSubmit () {
        let that = this
        let loginParams = {};
        that.loginBtn = true;
        // 使用账户密码登录
        if (that.customActiveKey === 'tab1') {
          that.form.validateFields([ 'username', 'password','inputCode', 'rememberMe' ], { force: true }, (err, values) => {
            if (!err) {
             
              // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
              //loginParams.password = md5(values.password)
              //loginParams.password = encryption(values.password,that.encryptedString.key,that.encryptedString.iv)

              const encrypt = new JSEncrypt();
              encrypt.setPublicKey(PUBLIC_KEY);
              loginParams.password = encrypt.encrypt(values.password);
              loginParams.username = encrypt.encrypt(values.username);
              loginParams.remember_me = values.rememberMe
              // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
              loginParams.captcha = that.inputCodeContent
              loginParams.checkKey = that.currdatetime
              that.Login(loginParams).then((res) => {                
                this.$refs.loginSelect.show(res.result)
                that.loginBtn = false;
                that.handleChangeCheckCode()
              }).catch((err) => {
                that.requestFailed(err);
                that.loginBtn = false;
                that.handleChangeCheckCode()
              });


            }else {
              that.loginBtn = false;
            }
          })
          // 使用手机号登录
        } else {

        }
      },
      stepCaptchaSuccess () {
        this.loginSuccess()
      },
      stepCaptchaCancel () {
        this.Logout().then(() => {
          this.loginBtn = false
          this.stepCaptchaVisible = false
        })
      },
      handleChangeCheckCode(){
        this.currdatetime = new Date().getTime();
        getAction(`/sys/randomImage/${this.currdatetime}`).then(res=>{
          if(res.success){
            this.randCodeImage = res.result
            this.requestCodeSuccess=true
          }else{
            this.$message.error(res.message)
            this.requestCodeSuccess=false
          }
        }).catch(()=>{
          this.requestCodeSuccess=false
        })
      },
      loginSuccess() {
        const deviceType = this.detectDeviceType();
        this.$router.push({ path: deviceType === 'pad' ? "/" : '/index' }).catch(() => {
          console.log('登录跳转首页出错,这个错误从哪里来的')
        })
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`,
        });
      },

      detectDeviceType() {
        const userAgent = navigator.userAgent;
        if (/Tablet|iPad|Linux|Android/i.test(userAgent)) {
          return 'pad';
        } else if (/Windows/i.test(userAgent)) {
          return 'PC';
        } else {
          return 'Unknown';
        }
      },

      requestFailed (err) {
        console.log('err',err)
        this.$notification[ 'error' ]({
          message: '登录失败',
          description: ((err.response || {}).data || {}).message || err.message || "请求出现错误，请稍后再试",
          duration: 4,
        });
        this.loginBtn = false;
      },

      validateInputCode(rule,value,callback){
        if(!value || this.verifiedCode==this.inputCodeContent){
          callback();
        }else{
          callback("您输入的验证码不正确!");
        }
      },
      generateCode(value){
        this.verifiedCode = value.toLowerCase()
      },
      inputCodeChange(e){
        this.inputCodeContent = e.target.value
      },
      loginSelectOk(){
        this.loginSuccess()
      },
      getRouterData(){
        this.$nextTick(() => {
          if (this.$route.params.username) {
            this.form.setFieldsValue({
              'username': this.$route.params.username
            });
          }
        })
      },
      //获取密码加密规则
      getEncrypte(){
        var encryptedString = Vue.ls.get(ENCRYPTED_STRING);
        if(encryptedString == null){
          getEncryptedString().then((data) => {
            this.encryptedString = data
          });
        }else{
          this.encryptedString = encryptedString;
        }
      },
    }
  }
</script>

<style lang="less" scoped>

  .user-layout-login {
    label {
      font-size: 14px;
    }

    .getCaptcha {
      display: block;
      width: 100%;
      height: 40px;
    }
    /deep/ input{
      background-color: rgba(0,0,0,0.1);
      color: white !important;
    }
    /deep/.has-error input,
    /deep/.has-error input:hover{
      background-color: rgba(0,0,0,0.1);
      color: white !important;
    }
    .forge-password {
      font-size: 14px;
    }

    button.login-button {
      padding: 0 15px;
      font-size: 16px;
      height: 40px;
      width: 100%;
      background-color: @primary-color;
    }

    .user-login-other {
      text-align: left;
      margin-top: 24px;
      line-height: 22px;

      .item-icon {
        font-size: 24px;
        color: white;
        margin-left: 16px;
        vertical-align: middle;
        cursor: pointer;
        transition: color .3s;

        &:hover {
          color: @primary-color;
        }
      }
    }
  }

</style>
<style lang="less">
  /* 全局背景透明设置 */
  body, html {
    background-color: transparent !important;
  }
  
  .main{
    background-color: transparent !important;
    
    .user-layout-login{
      background-color: transparent !important;
      
      /* 修复标签页相关白色背景 */
      .ant-tabs-nav .ant-tabs-tab-active{
        //color: @primary-color !important;
        color: #1890FF !important;
        background-color: transparent !important;
      }
      .ant-tabs-nav .ant-tabs-tab{
        background-color: transparent !important;
      }
      .ant-tabs-nav-container,
      .ant-tabs-nav-wrap,
      .ant-tabs-nav-scroll{
        background-color: transparent !important;
      }
      .ant-tabs-ink-bar{
        background-color: @primary-color;
      }
      
      /* 修复表单和标签页的白底问题 */
      .ant-tabs,
      .ant-tabs-content,
      .ant-tabs-content-holder,
      .ant-tabs-tabpane,
      .ant-form,
      .ant-form-item,
      .ant-row,
      .ant-col{
        background-color: transparent !important;
      }
      
      /* 修复输入框和按钮 */
      .ant-input-wrapper,
      .ant-input,
      .ant-btn{
        background-color: rgba(0,0,0,0.1) !important;
        border-color: rgba(255,255,255,0.2) !important;
      }
      
      .ant-input:focus,
      .ant-input:hover{
        border-color: @primary-color !important;
      }
      
      .ant-btn-primary{
        background-color: @primary-color !important;
        border-color: @primary-color !important;
      }
      
      /* 修复复选框 */
      .ant-checkbox-checked .ant-checkbox-inner{
        background-color: @primary-color;
        border-color: @primary-color;
      }
      
      /* 修复验证码图片容器 */
      img{
        background-color: transparent !important;
      }
    }
    
    .ant-checkbox-wrapper{
      color:white;
    }
  }
  
  .valid-error .ant-select-selection__placeholder{
    color: #f5222d;
  }
  
  /* 修复浏览器自动填充样式 */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-transition-delay: 111111s;
    -webkit-transition: color 111111s ease-out, background-color 111111s ease-out;
    -webkit-box-shadow: 0 0 0 1000px rgba(0,0,0,0.1) inset;
    -webkit-text-fill-color: white !important;
  }

</style>